import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../LandingPage/Footer";
import background from "../../assets/LandingPage/Background (1).png";
import TermsOfUse from "./TermsOfUse";
import PrivacyPolicy from "./PrivacyPolicy";
import CCPAPolicy from "./CCPAPolicy";
import Header from "../LandingPage/Header";

const LegalPage = () => {
  const { page } = useParams();
  const navigate = useNavigate();

  const navigateToSignUp = () => {
    navigate("/early-access-signup");
  };

  const normalizedPage =
    page === "terms-of-use"
      ? "Terms and Conditions"
      : page === "privacy-policy"
      ? "Privacy Policy"
      : page === "ccpa-policy"
      ? "CCPA Policy"
      : "";

  const handleRedirect = (selectedPage) => {
    navigate(
      `/legal/${
        selectedPage === "Terms and Conditions"
          ? "terms-of-use"
          : selectedPage === "Privacy Policy"
          ? "privacy-policy"
          : selectedPage === "CCPA Policy"
          ? "ccpa-policy"
          : "Privacy Policy"
      }`
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header
        navigateToSignUp={navigateToSignUp}
        buttonBgColor="#1E1E1E"
        buttonTextColor="#eaf524"
        logoFillColor="#1E1E1E"
        buttonText="Get Early Access to Smart Sourcing"
      />
      <div className="flex flex-grow justify-center items-center h-[495px] lg:h-[795px] bg-[#eaf524]">
        <h1
          className="text-black text-center text-ellipsis font-[700] text-[50px] sm:text-[80px]
        md:text-[100px]"
        >
          {normalizedPage}
        </h1>
      </div>

      <div className="flex flex-col md:flex-row gap-12 md:gap-32 text-left pt-20 pb-20">
        <img
          src={background}
          className="background-image-terms"
          alt="backgroundImage"
        />
        <div className="flex flex-col whitespace-nowrap pl-[62px] gap-5 text-xl text-[#515151]">
          <span
            onClick={() => handleRedirect("Terms and Conditions")}
            className={`${
              normalizedPage === "Terms and Conditions"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            Terms and Conditions
          </span>
          <span
            onClick={() => handleRedirect("Privacy Policy")}
            className={`${
              normalizedPage === "Privacy Policy"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            Privacy Policy
          </span>
          <span
            onClick={() => handleRedirect("CCPA Policy")}
            className={`${
              normalizedPage === "CCPA Policy"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            CCPA Policy
          </span>
        </div>

        {normalizedPage === "Terms and Conditions" && <TermsOfUse />}
        {normalizedPage === "Privacy Policy" && <PrivacyPolicy />}
        {normalizedPage === "CCPA Policy" && <CCPAPolicy />}
      </div>

      <Footer handleRedirect={handleRedirect} />
    </div>
  );
};

export default LegalPage;
